import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/config';
import { IntegrationIds } from '~/helpers/contactsIntegration';
import { ContactIntegrated } from '~/interfaces/integrations';
import ModalTickets from '../ModalTickets';
import SyncCallButton from '../SyncCallButton';

type Props = {
  contact: ContactIntegrated;
};

export default function ListItemActions({ contact }: Props) {
  const { integrationId, callId, externalId, integrationInfo } = contact;

  const integrationAccountId = integrationInfo?.integrationAccountId;

  const activeSession = useSelector(
    (state: RootState) => state.callCurrent.session
  );

  const [originalCallId, setOriginalCallId] = useState<string | null>(null);

  useEffect(() => {
    // @ts-ignore
    const xOriginalCallID = activeSession?.request?.getHeader(
      'X-Original-Callid'
    );
    if (xOriginalCallID) {
      setOriginalCallId(xOriginalCallID);
    }
  }, [activeSession]);

  const hasSyncCallIntegration =
    integrationId === IntegrationIds.SALESFORCE ||
    String(integrationId).startsWith(
      IntegrationIds.GO_HIGH_LEVEL_ID.toString()
    );

  const hasTicketsIntegration =
    callId &&
    externalId &&
    (integrationId === IntegrationIds.AUTO_TASK ||
      integrationId === IntegrationIds.ZENDESK_ID);

  const callIdForTickets =
    integrationId === IntegrationIds.AUTO_TASK
      ? originalCallId || callId // For AutoTask, prefer originalCallId if available
      : callId;

  return (
    <>
      {hasSyncCallIntegration && activeSession && (
        <SyncCallButton
          callId={callId}
          originalCallId={originalCallId}
          integrationId={integrationId}
          externalContactId={externalId}
          integrationAccountId={integrationAccountId || null}
        />
      )}

      {hasTicketsIntegration && (
        <ModalTickets
          callId={callIdForTickets}
          integrationId={integrationId}
          externalContactId={externalId}
        />
      )}
    </>
  );
}
